const FAQ_DATA = {
    1: {
        QUESTION: "Hva kan jeg fylle på?",
        ANSWER: "Du kan fylle på ulike ting; kronebeløp, ringeminutter I Norden, eller pakker som for eksempel inkluderer fri bruk av samtaler og/eller en viss datamengde.<br>Vi anbefaler Telia Kontant-pakker dersom du trenger å bruke mobildata.<br><ul><li>Telia Kontant: Velg mellom 3, 7, 12, 20 eller 50 GB (31 dager). Inkluderer fri bruk av tale, SMS og MMS. Inkluderer også Roam Like Home (lik bruk i EU, EØS, UK og Sveits). Pakker med kortere varighet er også tilgjengelig.</li><li>Saldo:  Fyll på med kronebeløp 50 – 500 NOK.</li><li>Datapakker: Kjøp ekstra data til mobilen din. Velg mellom 1, 5 eller 10 GB.</li><li>Tilleggstjeneste: For 9,- kan du kjøpe 1000 ringeminutter til Norden & Baltikum (ekskl. Norge).</li></ul>",
    },
    2: {
        QUESTION: "Jeg har litt penger på saldo, men får ikke ringt – hvorfor?",
        ANSWER: "Hvis du har en ren kronesaldo, så holdes nemlig en sum av for bruk av data – slik at du ikke skal gå i minus på saldoen. Derfor må du alltid ha minst 10 – 20 kroner i saldo for å kunne ringe ut.",
    },
    3: {
        QUESTION: "Hvor ofte må jeg fylle på kontantkortet for å beholde det?",
        ANSWER: "For at kontantkortet skal holdes aktivt, må du fylle på minst 50,- hvert år. Vi sender deg en SMS hvis det nærmer seg 12 måneder siden siste påfyll av minst 50,-.",
    },
} as const;

export default FAQ_DATA;
